import React from 'react';

const FlagIcon = ({ country, className = "" }) => {
  const countryLower = country?.toLowerCase();
  
  if (countryLower === 'sv') {
    return (
      <svg viewBox="0 0 16 10" className={className} style={{ display: 'block' }}>
        <rect width="16" height="10" fill="#006AA7"/>
        <rect x="5" y="0" width="2" height="10" fill="#FECC00"/>
        <rect x="0" y="4" width="16" height="2" fill="#FECC00"/>
      </svg>
    );
  }
  
  if (countryLower === 'en') {
    return (
      <svg viewBox="0 0 60 30" className={className} style={{ display: 'block' }}>
        <rect width="60" height="30" fill="#012169"/>
        <path d="M0,0 L60,30 M60,0 L0,30" stroke="#fff" strokeWidth="6"/>
        <path d="M0,0 L60,30 M60,0 L0,30" stroke="#C8102E" strokeWidth="4"/>
        <path d="M30,0 v30 M0,15 h60" stroke="#fff" strokeWidth="10"/>
        <path d="M30,0 v30 M0,15 h60" stroke="#C8102E" strokeWidth="6"/>
      </svg>
    );
  }
  
  if (countryLower === 'de') {
    return (
      <svg viewBox="0 0 5 3" className={className} style={{ display: 'block' }}>
        <rect width="5" height="1" y="0" fill="#000"/>
        <rect width="5" height="1" y="1" fill="#D00"/>
        <rect width="5" height="1" y="2" fill="#FFCE00"/>
      </svg>
    );
  }
  
  if (countryLower === 'fr') {
    return (
      <svg viewBox="0 0 3 2" className={className} style={{ display: 'block' }}>
        <rect width="1" height="2" x="0" fill="#002395"/>
        <rect width="1" height="2" x="1" fill="#FFF"/>
        <rect width="1" height="2" x="2" fill="#ED2939"/>
      </svg>
    );
  }
  
  return null;
};

export default FlagIcon;
